import { render, staticRenderFns } from "./TabelaCabecalho.vue?vue&type=template&id=23e8de1f&scoped=true&lang=pug"
import script from "./TabelaCabecalho.vue?vue&type=script&lang=js"
export * from "./TabelaCabecalho.vue?vue&type=script&lang=js"
import style0 from "./TabelaCabecalho.styl?vue&type=style&index=0&id=23e8de1f&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e8de1f",
  null
  
)

export default component.exports